//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
import "../CAM/CAM.Ude.js";
import "../CAM/CAM.Cycle.js";
let d=[[[1,"CycleEvent",0,"CAM.Ude",0],[1,"CycleTable",0,"CAM.Cycle",0],[0,"OptimizationMethod",1,0],[0,"TargetPocket",1,"CAM.NCGroup",0]],[[["name"],"GetCustomizableItemBuilder",{R_:{ciBuilderTag:"TaggedObject"}},1,0],[["count"],"GetCustomizableItemNames",{R_:{names:""}},0,0]],[]];
SPLM.CAM.ParamBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ParamBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ParamBuilder.OptimizationTypes = Object.freeze({
    "None" : "None", "MinimizeTravel" : "MinimizeTravel", "Band" : "Band"});

export default SPLM;